import { formatCountText } from "~/utils/strings";
import { getRemediationTimeValue } from "../OnboardingCellRenderer/RemediationInvite/util";

export interface RemediationBannerData {
  mainText: string;
  requestsSent?: number;
  lastRequested?: string;
}

export const getRemediationBanner = (
  dateSent?: string,
  sentCount?: number,
): RemediationBannerData | null => {
  if (!dateSent) return null;

  const result = getRemediationTimeValue(dateSent);
  let lastRequestedText: string;

  if (typeof result === "string") {
    lastRequestedText = result;
  } else {
    lastRequestedText = `${formatCountText(result, "day")} ago`;
  }

  if (sentCount) {
    return {
      mainText:
        "Remediation request was already sent. Please confirm if you want to send another one.",
      requestsSent: sentCount,
      lastRequested: lastRequestedText,
    };
  }

  let baseMessage: string;

  if (result === "Just now") {
    baseMessage = `Remediation request was already sent just now. Please confirm if you want to send another one.`;
  } else if (result === "Sent today") {
    baseMessage = `Remediation request was already sent today. Please confirm if you want to send another one.`;
  } else {
    baseMessage = `Remediation request was already sent ${lastRequestedText.toLowerCase()}. Please confirm if you want to send another one.`;
  }

  return {
    mainText: baseMessage,
  };
};
